import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import ReviewPage from './Review/ReviewPage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout scope={'whisper'} websiteLabel={"whisper-communication.fr"}>
      <ReviewPage isActive={navigationContext.activeAppKey === 'review'} />
    </MainLayout>
  );
}

export default Home;
